import * as React from 'react';
import { getSvgIcon } from '../Device2NIcon/helpers';

export interface IIcon2NProps {
  children?: React.ReactNode;
  name: string;
}

export default function Icon2N({ name }: IIcon2NProps) {
  return <img width={70} height={70} alt={name} src={getSvgIcon(name)} />;
}
